<div class="dsm-flex-container gallery-card {{componentStyle}}" [ngStyle]="{'background-color': backgroundColor}" [ngClass]="{'has-title': title}">
    <h2 *ngIf="title" class="gallery-card-title">{{title}}</h2>
    <div class="panel-card-wrapper">
        <div class="panel" *ngFor="let item of subCards; trackBy: trackByFn">
            <gallery-sub-cards [componentData]="item" [pageUrl]="pageUrl" [parentCardName]="componentData.name" [useLocaleOverride]="useLocaleOverride"></gallery-sub-cards>
        </div>
    </div>
</div>
